import React from 'react';
import { ScorecardTemplate } from '../../../entities/applicant_tracking/ScorecardTemplate';
import { Col, Row } from 'reactstrap';
import { SurveySection } from '../../../entities/survey_engine/SurveySection';
import { Chip } from '../../Chip';

interface PropTypes {
  scorecardTemplate: ScorecardTemplate;
}

function RatingsBox(props: { section: SurveySection }) {
  return (
    <div className='rounded-2 border border-blue-gray-700 px-3 pt-2 pb-1 h-100'>
      <div className='mt-1 fs-5 fw-bold mb-3'>{props.section.sectionName}</div>
      {props.section.questions.map((question, index) => {
        return (
          <Chip
            key={index}
            className='bg-light-info text-primary mw-100 fw-semibold fs-6 me-2 mb-2'
          >
            {question.title}
          </Chip>
        );
      })}
    </div>
  );
}

function ProsAndCons() {
  return (
    <>
      <div className='fs-5 text-dark-500 mb-2 pb-1'>Open Text Area</div>
      <Row>
        <Col xs='6'>
          <div className='rounded-2 border border-blue-gray-700 px-3 py-2'>
            <div className='fs-5 fw-bold'>Pros</div>
          </div>
        </Col>
        <Col xs='6'>
          <div className='rounded-2 border border-blue-gray-700 px-3 py-2'>
            <div className='fs-5 fw-bold'>Cons</div>
          </div>
        </Col>
      </Row>
    </>
  );
}

export function ScorecardTemplateTable(props: PropTypes) {
  const sections = props.scorecardTemplate.template.sections.sort(
    (a, b) => a.order - b.order,
  );
  const numRows = Math.ceil(sections.length / 2);
  const rowIndices = Array.from(Array(numRows).keys());

  return (
    <div className='mt-3 pt-1'>
      <div className='text-dark-500 fs-5 mb-2 pb-1'>1-5 Scale Rating</div>
      {rowIndices.map((rowIndex) => {
        return (
          <Row className='gx-4 mb-3 pb-1' key={rowIndex}>
            <Col xs='6' className='d-flex flex-column'>
              <RatingsBox section={sections[rowIndex]} />
            </Col>
            {sections[rowIndex + numRows] && (
              <Col xs='6' className='d-flex flex-column'>
                <RatingsBox section={sections[rowIndex + numRows]} />
              </Col>
            )}
          </Row>
        );
      })}
      <ProsAndCons />
    </div>
  );
}
